// Display-year helpers — the platform's YEAR-SELECTOR convention (s72, owner-locked):
// list views (Invoices, One-time Expenses; Time via its month+year picker) show a Year
// selector ONLY when their loaded items span more than one calendar year, defaulting to
// the current year.
//
// JANUARY GRACE (owner-refined, s72): through January, items dated the PREVIOUS December
// ALSO appear under the current year's view, so year-end work stays visible while it's
// being invoiced. The prior-year option always shows its FULL January–December — the
// grace is additive, never subtractive.
//
// Mileage is exempt by design — it is a strict month view at all times.

/** True when an ISO date (YYYY-MM-DD…) belongs to a year's VIEW: its own calendar year,
 *  plus — during January only — the previous December under the current year (the grace). */
export function inDisplayYear(dateIso: string, year: number, now: Date = new Date()): boolean {
  const y = Number(dateIso.slice(0, 4));
  if (y === year) return true;
  return (
    now.getMonth() === 0 &&
    year === now.getFullYear() &&
    y === year - 1 &&
    Number(dateIso.slice(5, 7)) === 12
  );
}

/** Distinct calendar years across a set of dates, newest first (the selector's options). */
export function collectDisplayYears(dates: ReadonlyArray<string | null | undefined>): number[] {
  const s = new Set<number>();
  for (const d of dates) if (d) s.add(Number(d.slice(0, 4)));
  return [...s].sort((a, b) => b - a);
}

/** The label for a year option — flags the January grace on the current year. */
export function displayYearLabel(year: number, now: Date = new Date()): string {
  if (now.getMonth() === 0 && year === now.getFullYear()) return `${year} (incl. Dec ${year - 1})`;
  return String(year);
}
